import { render, staticRenderFns } from "./infoSolicitudView.vue?vue&type=template&id=639c369f&"
import script from "./infoSolicitudView.vue?vue&type=script&lang=js&"
export * from "./infoSolicitudView.vue?vue&type=script&lang=js&"
import style0 from "./infoSolicitudView.vue?vue&type=style&index=0&id=639c369f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports